"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Placeholder.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        "class": "position-relative w-100 text-center h-75"
      },
    marko_attrs1 = {
        "class": "btn btn-lg theme-bg-lighten border-top rounded-0 position-absolute w-100 left-0 bottom-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (input.type == "image") {
    out.be("div", {
        "class": marko_classValue("position-relative d-flex align-items-center image-placeholder theme-bg-fade text-center " + input.class),
        style: marko_styleValue({
            padding: "20%",
            height: input.height || "auto"
          })
      }, "0", component, null, 1);

    out.e("div", marko_attrs0, "1", component, 1)
      .e("i", {
          "class": marko_classValue(("bx " + (input.icon || "bx-image")) + " blue-grey-text text-lighten-3"),
          style: marko_styleValue(("font-size:" + (input.size == "lg" ? "500" : "300")) + "%")
        }, "2", component, 0, 1);

    if (input.btn) {
      out.be("button", marko_attrs1, "3", component, null, 0, {
          onclick: __component.d("click", () => component.emit('click'), false)
        });

      Locale_tag({
          text: input.btnLabel
        }, out, __component, "4");

      out.ee();
    }

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
